import { DiscordCategory, Platform } from "@prisma/client";
import { TriggerCreate } from "../../libs/types/src";

const workspace = "7c56ffb6-6e3f-445d-949a-e96160e04806";
const communityId = "895195267081568276";

export const arpeggiCategory: any[] = [
  {
    name: "Onboarding-1",
    type: "onboarding",
    guild: communityId,
    categoryId: "1022385697161760788",
    workspace: workspace,
  },
  {
    name: "Onboarding-1",
    type: "onboarding",
    guild: communityId,
    categoryId: "1022385698248077312",
    workspace: workspace,
  },
];

const stepCommon: {
  platform: Platform;
  communityId: string;
  workspace: string;
} = {
  platform: "discord",
  communityId,
  workspace,
};

export const arpeggiTrigger: TriggerCreate = {
  platform: "discord",
  communityId,
  workspace,
  authorUserId: "759968155907915776-895195267081568276",
  name: "arpeggi onboard test with button",
  type: "button_click",
  configs: {
    messages: [
      {
        id: "1022891025645187214",
        buttonIds: ["buttonTriggerInteraction"],
      },
    ],
    responseOnError: "Something is wrong!", // by default ephemeral = true
    responseOnComplete:
      "Continue the test flow in this channel: <#{{arpeggi-step0.channelId}}>",
  },
  steps: [
    {
      id: "arpeggi-step0",
      type: "create_channel",
      configs: {
        channelName: "arpeggi-onboard-{{user.username}}",
        userIds: ["{{user.id}}"],
        isPrivate: true,
        channelType: "onboarding",
      },
      transitions: [{ targetStepId: "arpeggi-step1" }],
    },
    {
      ...stepCommon,
      id: `arpeggi-step1`,
      type: "send_message",
      configs: {
        channelId: `{{arpeggi-step0.channelId}}`,
        message: `Welcome <@{{user.id}}> to Arpeggi, web3’s home for music creation and publishing! With Arpeggi, anyone can create, upload, publish, and explore sounds and songs for other musicians to use. In this channel, we have our admins: Wilton, James, Evan & Kyle. \n\nhttps://pbs.twimg.com/profile_banners/1444199345062957057/1655399143/600x200  `,
      },
      transitions: [
        {
          targetStepId: `arpeggi-step-test-captcha`,
        },
      ],
    },
    {
      id: `arpeggi-step-test-captcha`,
      type: "test_captcha",
      configs: {
        channelId: `{{arpeggi-step0.channelId}}`,
        userId: "{{user.id}}",
        guildId: communityId,
        message:
          "Before we show you our Discord, please verify you are a human :) ",
      },
      transitions: [
        {
          targetStepId: `arpeggi-hear-about-us`,
          when: {
            userResponse: {
              type: "captcha-result",
              channelId: `{{arpeggi-step0.channelId}}`,
              userId: "{{user.id}}",
              succeeded: true,
            },
          },
        },
        {
          targetStepId: `arpeggi-failed-kick-member`,
          when: {
            userResponse: {
              type: "captcha-result",
              channelId: `{{arpeggi-step0.channelId}}`,
              userId: "{{user.id}}",
              succeeded: false,
            },
          },
        },
      ],
    },

    {
      id: `arpeggi-failed-kick-member`,
      type: "send_message",
      configs: {
        channelId: `{{arpeggi-step0.channelId}}`,
        message:
          "Failed captcha verification. Member would be kicked. Please re-trigger onboarding flow.",
      },
      transitions: [],
    },

    {
      ...stepCommon,
      id: `arpeggi-hear-about-us`,
      type: "send_survey",
      configs: {
        channelId: `{{arpeggi-step0.channelId}}`,
        message: `Let's get startd. \n\nHow did you hear about Arpeggi?`,
        type: "buttons", // by default it's "emojis"
        options: [
          {
            emoji: "",
            id: "twitter",
            label: "Twitter",
          },
          {
            emoji: "",
            id: "insta",
            label: "Instagram",
          },
          {
            emoji: "",
            id: "friend",
            label: "A friend",
          },
          {
            emoji: "",
            id: "stumbled",
            label: "I stumbled in",
          },
          {
            emoji: "",
            id: "other",
            label: "Other",
          },
        ],
      },
      transitions: [
        {
          targetStepId: `arpeggi-brings-you-here`,
          when: {
            userResponse: {
              type: "button",
              userId: "{{user.id}}",
              messageId: `{{arpeggi-hear-about-us.messageId}}`,
              buttonId: "twitter",
            },
          },
        },
        {
          targetStepId: `arpeggi-brings-you-here`,
          when: {
            userResponse: {
              type: "button",
              userId: "{{user.id}}",
              messageId: `{{arpeggi-hear-about-us.messageId}}`,
              buttonId: "insta",
            },
          },
        },
        {
          targetStepId: `arpeggi-brings-you-here`,
          when: {
            userResponse: {
              type: "button",
              userId: "{{user.id}}",
              messageId: `{{arpeggi-hear-about-us.messageId}}`,
              buttonId: "friend",
            },
          },
        },
        {
          targetStepId: `arpeggi-brings-you-here`,
          when: {
            userResponse: {
              type: "button",
              userId: "{{user.id}}",
              messageId: `{{arpeggi-hear-about-us.messageId}}`,
              buttonId: "stumbled",
            },
          },
        },
        {
          targetStepId: `arpeggi-other-message`,
          when: {
            userResponse: {
              type: "button",
              userId: "{{user.id}}",
              messageId: `{{arpeggi-hear-about-us.messageId}}`,
              buttonId: "other",
            },
          },
        },
      ],
    },
    {
      ...stepCommon,
      id: `arpeggi-other-message`,
      type: "send_message",
      configs: {
        channelId: `{{arpeggi-step0.channelId}}`,
        message: `Please enter where did you hear about us! You can type skip to skip`,
      },
      transitions: [
        {
          targetStepId: `arpeggi-brings-you-here`,

          when: {
            userResponse: {
              type: "message",
              userId: "{{user.id}}",
              channelId: `{{arpeggi-step0.channelId}}`,
            },
          },
        },
      ],
    },
    {
      ...stepCommon,
      id: `arpeggi-brings-you-here`,
      type: "send_multiple_select",
      configs: {
        channelId: `{{arpeggi-step0.channelId}}`,
        doneButton: { label: "I'm all set" },
        message: `\n\nWhat brings you here? (Feel free to select multiple)  
            `,
        type: "buttons",
        options: [
          {
            emoji: "⬆️",
            id: "upload",
            label: "Upload samples for others to use",
          },
          { emoji: "💻", id: "use", label: "Use free in-browser DAW" },
          { emoji: "⚡️", id: "mint", label: "Mint my songs as NFTs" },
          { emoji: "🎧", id: "listen", label: "Listen to new music" },
          {
            emoji: "📚",
            id: "learning",
            label: "Just learning - I am new to web3 music",
          },
        ],
      },
      transitions: [
        {
          targetStepId: "arpeggi-step-email",
          when: {
            // the user response will only be dispatched once the user completes the multi-selection.
            userResponse: {
              type: "multiple-select",
              userId: "{{user.id}}",
              messageId: `{{arpeggi-brings-you-here.messageId}}`,
            },
          },
        },
        // {
        //   targetStepId: `arpeggi-language-step`,
        //   when: {
        //     userResponse: {
        //       type: "message",
        //       channelId: `{{arpeggi-step0.channelId}}`,
        //       userId: "{{user.id}}",
        //       content: "skip",
        //     },
        //   },
        // },
      ],
    },
    // {
    //   id: `arpeggi-learn`,
    //   if: {
    //     condition: {
    //       "arpeggi-brings-you-here.userResponse.optionIds": {
    //         array_contains: "learn",
    //       },
    //     },
    //     elseStepId: `arpeggi-meet`,
    //   },
    //   type: "edit_roles",
    //   configs: {
    //     userIds: ["{{user.id}}"],
    //     addRoles: ["Enthusiast"],
    //     removeRoles: ["await-onboarding"],
    //   },
    //   transitions: [
    //     {
    //       targetStepId: `arpeggi-learn-message`,
    //     },
    //   ],
    // },
    {
      id: "arpeggi-step-email",
      type: "send_message",
      configs: {
        channelId: "{{arpeggi-step0.channelId}}",
        message: `Please share your email address so we can keep you updated on the latest. We won’t spam you! Feel free to skip if you prefer not giving your email address.`,
      },
      transitions: [
        {
          targetStepId: "arpeggi-email-idle",
        },
      ],
    },
    {
      id: "arpeggi-email-idle",
      type: "idle",
      configs: {
        reference: "arpeggi-step-email",
      },
      transitions: [
        {
          targetStepId: `arpeggi-step-final`,
          when: {
            userResponse: {
              type: "message",
              channelId: "{{arpeggi-step0.channelId}}",
              userId: "{{user.id}}",
              content: {
                has: "email",
              },
            },
          },
        },
        {
          targetStepId: "arpeggi-step-invalid-email",
          when: {
            userResponse: {
              type: "message",
              channelId: "{{arpeggi-step0.channelId}}",
              userId: "{{user.id}}",
              content: {
                hasnot: "email",
              },
            },
          },
        },
        {
          targetStepId: `arpeggi-step-final`,
          when: {
            userResponse: {
              type: "message",
              channelId: `{{arpeggi-step0.channelId}}`,
              userId: "{{user.id}}",
              content: "skip",
            },
          },
        },
      ],
    },
    {
      id: "arpeggi-step-invalid-email",
      type: "send_message",
      configs: {
        channelId: "{{arpeggi-step0.channelId}}",
        message: `Hmm, that doesn't look like an email. Please try again.`,
      },
      transitions: [
        {
          targetStepId: "arpeggi-email-idle",
        },
      ],
    },

    {
      ...stepCommon,
      id: `arpeggi-step-final`,
      type: "send_message",
      configs: {
        channelId: `{{arpeggi-step0.channelId}}`,
        message: `Thank you for joining us! To get started, take a quick tutorial to learn Arpeggi or introduce yourself in <#903120035915104286>.\n\nPS: This channel will be auto deleted in 24 hours. If you have any questions, after please head to <#895203486441046017>!`,
      },
      transitions: [
        {
          targetStepId: `arpeggi-step7`,
        },
      ],
    },
    {
      id: "arpeggi-step7",
      type: "delete_channel",
      configs: {
        delaySeconds: 60 * 60 * 24,
        channelId: "{{arpeggi-step0.channelId}}",
      },
      transitions: [],
    },
  ],
};
export { arpeggiTrigger as trigger, arpeggiCategory as categories };
